// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { AlternatePackagingCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { GetAlternatePackagingApiParameter } from "@store/Framework/Services/AlternatePackagingService";
import { ProductAlternatePackagingState } from "@store/Framework/Store/Greif/Data/AlternatePackaging/AlternatePackagingState";
import { Draft } from "immer";

const initialState: ProductAlternatePackagingState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    alternativeSummary: "",
    alternativeType: "",
    currentProductNumber: "",
};

const actions = {
    "Greif/Data/AlternatePackaging/BeginLoadAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: { parameter: GetAlternatePackagingApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/AlternatePackaging/CompleteLoadAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: {
            parameter: GetAlternatePackagingApiParameter;
            collection: AlternatePackagingCollectionModel;
        },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection =>
            Object(collection.alternatePackagingAttributes!),
        );
    },

    "Greif/Data/AlternatePackaging/FailedToLoadAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: { model: AlternatePackagingCollectionModel },
    ) => {
        delete draft.isLoading[action.model.id];
        if (draft.errorStatusCodeById) {
            delete draft.errorStatusCodeById[action.model.id];
        }
    },

    "Greif/Data/AlternatePackaging/Reset": () => {
        return initialState;
    },

    "Greif/Data/AlternatePackaging/SetAlternatePackaging": (
        draft: Draft<ProductAlternatePackagingState>,
        action: {
            parameter: {
                alternativeSummary: string;
                alternativeType: string;
                currentProductNumber: string;
            };
        },
    ) => {
        draft.alternativeSummary = action.parameter.alternativeSummary;
        draft.alternativeType = action.parameter.alternativeType;
        draft.currentProductNumber = action.parameter.currentProductNumber;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataAlternatePackagingActions = Parameters<typeof reducer>[1];
export default reducer;
